import { Button, Typography } from "@mui/material";
import InfoPage from "../components/infoPage/InfoPage";
import LoggedOutIcon from "../icons/LoggedOutIcon";

interface Props {
  href: string;
  hideLoginRedirectButton?: boolean | undefined;
}

const LoggedOut = ({ href, hideLoginRedirectButton }: Props) => {
  return (
    <InfoPage
      Icon={<LoggedOutIcon />}
      title="You've logged out."
      subtitle={<Typography color="textSecondary">It&apos;s a good idea to close the page.</Typography>}
    >
      {!hideLoginRedirectButton && (
        <Button variant="outlined" color="primary" href={href} sx={{ width: "10rem" }}>
          Back to Sign In page
        </Button>
      )}
    </InfoPage>
  );
};

export default LoggedOut;
